import { render, staticRenderFns } from "./BudgetModal.vue?vue&type=template&id=6d0ff3be&scoped=true&"
import script from "./BudgetModal.vue?vue&type=script&lang=ts&"
export * from "./BudgetModal.vue?vue&type=script&lang=ts&"
import style0 from "./BudgetModal.vue?vue&type=style&index=0&id=6d0ff3be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0ff3be",
  null
  
)

export default component.exports